
export class EventGroups {

    static groups : {[key: string]: string[]} = {
        'DESLIZAMENTO': [
            'DESLIZAMENTO',
            'RISCO DE DESLIZAMENTO',
            'ESCORREGAMENTO',
            'DESLIZAMENTO DE ENCOSTA',
            'TALUDE',
            'RISCO DE ESCORREGAMENTO',
            'MOVIMENTO/QUEDA DE BLOCOS/LASCAS',
        ],
        'ALAGAMENTO': [
            'ALAGAMENTO',
            'INUNDAÇÃO',
        ],
        'DESABAMENTO': [
            'DESABAMENTO'
        ]
    };

    static colors: {[key: string]: string} = {
        'DESLIZAMENTO': '#664422',
        'ALAGAMENTO': '#6600EE',
        'DESABAMENTO': '#505050',
    };

    /**
     * Obtém o nome do grupo relacionado ao evento.
     * 
     * @param event nome do evento (p. ex. 'ESCORREGAMENTO', 'INUNDAÇÃO')
     * @returns grupo ao qual o evento pertence (p. ex. 'DESLIZAMENTO', 'ALAGAMENTO')
     */
    static getGroup(event: string): string {

        for (let key of Object.keys(this.groups)) {
            for (let value of this.groups[key]) {
                if (event.includes(value)) {
                    return key;
                }
            }
        }
        return 'INDEFINIDO';
    }

    /**
     * Obtém a cor relacionada ao grupo do evento.
     * 
     * @param event nome do evento (p. ex. 'ESCORREGAMENTO', 'INUNDAÇÃO')
     * @returns cor associada ao grupo
     */
    static getColor(event: string): string {
        let group = this.getGroup(event);
        return (group in this.colors) ? this.colors[group] : '#000';
    }
}